<template>
  <div class="title-wrap">
    {{titleText}}
  </div>
</template>

<script>
export default {
  name: 'iBtn',
  props: {
    titleText: String
  }
}
</script>i

<style lang="stylus" scoped>
.title-wrap
  margin-top 10px
  margin-bottom 10px
  font-size 18px
  line-height 1
  color #333
  font-weight bold
</style>
